import { createContext, useContext, type PropsWithChildren } from 'react';

export interface ChannelBrand {
  displayName: string;
  publicWebOrigin: string;
}

export const WEB_BRAND: ChannelBrand = {
  displayName: '펫리듬',
  publicWebOrigin: 'https://neulgyeote.pages.dev',
};

const BrandContext = createContext<ChannelBrand>(WEB_BRAND);

export function BrandProvider({ value, children }: PropsWithChildren<{ value?: ChannelBrand }>) {
  return <BrandContext.Provider value={value ?? WEB_BRAND}>{children}</BrandContext.Provider>;
}

export function useBrand(): ChannelBrand {
  return useContext(BrandContext);
}
